export const DATA_6 = {
    name: '香港氣候變化',
    tabs: [
        {
            name: '報章社論',
            url: 'http://news.example.com/hk-trees-climate',
            contents: [
                { type: 'image', src: '/secondary/tasks/C2-P1-banner.png' },
                {
                    type: 'html', html: `
                            <div style='width: 100%; padding-left:0%; padding-right:0%; display: flex; flex-direction: column; align-items: start;'>
                            
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;從超強颱風、酷熱天氣，到暴雨和水浸，香港近年經常受到極端天氣影響。除了這些容易察覺的變化，城市裏的植物也出現了一些異常情況，部分植物的落葉與開花模式出現明顯變化，令人擔憂。其中，木棉樹和鳳凰木的情況尤其受到關注。木棉一般在三月至四月開花，鳳凰木則多在六月至七月開花，但近年部分樹木的花期比以往提早。與此同時，一些原本應在冬季落葉的樹木也出現延遲落葉，甚至沒有落葉。</p><br/>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;植物的開花與落葉，原本與季節變化緊密相關。這些規律一旦改變，所影響的不只是城市四季的面貌。香港教育大學地理及環境科學研究講座教授詹志勇警告，開花時間改變可能擾亂昆蟲、雀鳥和蝙蝠等生物的傳粉活動，進而影響食物鏈，甚至威脅人類的糧食安全。學界建議進行一項為期五至十年的系統性研究，以全面了解植物生長週期的變化，並制訂保護城市綠化地帶的策略。</p><br/>
                        </div>
                    </div>` },
                { type: 'image', src: '/secondary/tasks/C2-P1-img.png' },
                {
                    type: 'html', html: `<div class='w-full flex flex-col' style='margin-top: 16px; padding-left: 0%; padding-right: 0%; gap: 16px;'>
                        <div style='width: 100%; padding-left:0%; padding-right:0%; display: flex; flex-direction: column; align-items: start;'>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;令人欣慰的是，香港目前正積極採取不同措施應對極端天氣，例如利用機械人清理渠道，減少暴雨期間的淤塞和水浸。不過，除了處理眼前的問題，我們也需要了解自然環境正在發生甚麼變化，以及這些變化為何出現。詹教授指出，如果能長期記錄植物的開花、落葉和生長情況，我們便更容易看出這些變化是否持續，也有助及早找出合適的應對方法。</p><br/>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;這類研究往往需要多年，才看得出較清楚的趨勢，但這並不代表我們可以袖手旁觀。風暴過後，人們可能很快便忘記它帶來的影響；樹木卻會留下環境改變的跡象。從這個角度看，城市中的樹木就像一個長期記錄環境變化的「生態晴雨表」，提醒我們持續觀察身邊的變化，並及早作出準備。</p><br/>
                            <br/><div class='w-full flex justify-center items-end flex flex-col' style='margin-top: 6px; font-weight: 300;'>
                                資料來源：改編自《南華早報》
                            </div><br/>
                        </div>
                    </div>` },
                {
                    type: 'ai-comments',
                    comment_1: {
                        name: 'Cathy N.',
                        name_abbr: 'CN',
                        comment: '今年二月下旬，我就已經在銅鑼灣看到了木棉開花，比我印象中早了差不多三個星期。附近幾棵木棉也差不多，以前好像要到三月底或四月才會看到花。不過，我只看了這一帶的幾棵樹，也不知道只是今年比較特別，還是真的愈來愈早。'
                    },
                    comment_2: {
                        name: 'Ben H.',
                        name_abbr: 'BH',
                        comment: '我在大埔滘記錄木棉開花差不多五年了，近幾年的確比以前早，有些年份花期也比較短。不過，我自己記錄的地方不多，幾棵樹也不能代表全香港。如果政府和大學能長期記錄不同地區、不同品種的樹木，應該會更容易看出到底是不是一個長期變化。'
                    },
                    comment_3: {
                        name: 'Rita K.',
                        name_abbr: 'RK',
                        comment: '我覺得大家不用一看到提早開花，就馬上認為一定是氣候變化。植物的花期本來每年都可能有些差別，樹齡、健康狀況、修剪方式和附近環境也可能帶來影響。我家附近幾棵木棉今年和去年差不多，沒有明顯提早。不過，我自己的觀察範圍也很有限，所以還是要多看幾年，再比較不同地區和不同品種的樹木，才比較能判斷這是不是長期變化。'
                    },
                    comment_ai: {
                        comment: '三位留言者分享了各自觀察木棉花期的情況，範圍和年期各有不同。這些觀察證實，香港木棉花期已因氣候變化而整體提早。'
                    }
                },
            ]
        },
        {
            name: '科學文章',
            url: 'http://science.example.com/climate-change-causes',
            contents: [
                {
                    type: 'image',
                    src: '/secondary/tasks/C2-P2-banner.png',
                },
                {
                    type: 'html', html: `<br/>
                    
                        
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;自18世紀起，工業活動快速發展，人類大量燃燒煤、石油和天然氣。這些化石燃料會釋放大量溫室氣體。當大氣中的溫室氣體愈來愈多，溫室效應便會加強，令全球氣溫上升。現時，人類活動對氣候的影響已超過太陽和火山活動等自然因素。</p><br/>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;人類活動產生的主要溫室氣體包括二氧化碳、甲烷和氧化亞氮。它們的來源並不完全相同，例如能源使用、交通、農業和土地利用等活動，都可能增加溫室氣體排放。部分溫室氣體進入大氣後，可以停留數十年，甚至幾個世紀。因此，即使日後減少排放，過去排出的氣體仍可能繼續影響氣候。</p><br/>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;全球變暖帶來的影響也不只是氣溫升高。它還可能改變降雨情況和極端天氣出現的頻率，並進一步影響植物開花、落葉等生長規律。因此，科學家認為，除了減少溫室氣體排放，我們也需要持續觀察氣候和自然環境的變化。</p><br/>
                            <br/><br/>
                        
                    <div class='w-full flex justify-center items-end flex flex-col' style='margin-top: 6px; font-weight: 300;'>
                                資料來源：改編自香港天文台
                            </div><br/><br/>` }
            ]
        }
    ],
    questions: [
        {
            type: 'display-text',
            html: '二月下旬的一個週末，你和嘉朗、子晴到公園散步時，發現路邊的木棉樹已經開出鮮紅色的花朵。你停下腳步觀察，發現附近幾棵木棉也幾乎同時開花。子晴說，以往好像沒有這麼早看到木棉花。你聽後感到有點疑惑，回到家後，你上網搜尋木棉花期與天氣的關係，看到一篇評論文章。<br/><br/>點擊「下一頁」來閱讀第一個來源。'
        },
        {
            id: '1',
            type: '選擇題',
            question: '1. 根據社論，針對植物生長週期，學界建議進行的系統性研究預計為期多久？',
            subtitle: '參考右側的「報章社論」，作答本題。',
            options: [
                { text: 'A. 三至四個月' },
                { text: 'B. 一至兩年' },
                { text: 'C. 五至十年' },
                { text: 'D. 十年以上' },
            ],
            tab: 0
        },
        {
            id: '2',
            type: '選擇題',
            question: '2. 文中第二段提到「這些規律一旦改變」，「這些規律」是指甚麼？',
            subtitle: '參考右側的「報章社論」，作答本題。',
            options: [
                { text: 'A. 植物的開花、落葉會隨季節改變' },
                { text: 'B. 昆蟲和雀鳥會在開花時協助傳粉' },
                { text: 'C. 極端天氣會令植物生長出現變化' },
                { text: 'D. 科學家會長期記錄植物生長情況' },
            ],
            tab: 0,
        },
        {
            id: '3',
            type: '選擇題',
            question: '3. 社論提到香港已在利用科技減少極端天氣帶來的影響，但作者仍主張長期記錄自然環境的變化。由此可以推斷甚麼？',
            subtitle: '參考右側的「報章社論」，作答本題。',
            options: [
                { text: 'A. 防災措施主要用來記錄環境變化' },
                { text: 'B. 防災措施不能取代長期環境觀察' },
                { text: 'C. 長期觀察主要用來評估防災效果' },
                { text: 'D. 長期記錄比即時防災措施更重要' },
            ],
            tab: 0,
        },
        {
            id: '4',
            type: '選擇題',
            question: '4. 綜合社論第二段的內容，以下哪項最能概括這一段的中心意思？',
            subtitle: '參考右側的「報章社論」，作答本題。',
            options: [
                { text: 'A. 花期改變可能影響傳粉活動，需要關注' },
                { text: 'B. 植物生長週期正在改變，需要持續觀察' },
                { text: 'C. 植物變化威脅糧食安全，應增加糧食產量' },
                { text: 'D. 植物生長規律改變影響深遠，需長期研究' },
            ],
            tab: 0,
        },
        {
            id: '5',
            type: '選擇題',
            question: '5. 仔細閱讀三則讀者留言及其下方的AI總結。以下哪項對AI總結的評價不正確？',
            subtitle: '參考右側的讀者留言及AI總結，作答本題。',
            options: [
                { text: 'A. AI把局部觀察擴大為全港整體趨勢' },
                { text: 'B. AI把可能的成因說成已經得到證實' },
                { text: 'C. AI忽略其他因素也可能影響植物花期' },
                { text: 'D. AI指出仍需長期比較，才能判斷趨勢' },
            ],
            tab: 0,
        },
        {
            id: '6',
            type: '表格問題',
            question: '6. 以下陳述摘錄或改寫自社論和讀者留言。請判斷每項陳述主要屬於可以查證的「事實」，還是帶有判斷或評價的「觀點」。',
            subtitle: '參考右側的「報章社論」及讀者留言，作答本題。',
            header: ['陳述', '事實', '觀點'],
            table: [
                { text: '（1）木棉樹和鳳凰木的一般花期分別在春季和夏季。' },
                { text: '（2）研究植物生長規律是香港應對氣候風險的重要工作。' },
                { text: '（3）植物生長異常與極端天氣同樣值得市民關注。' },
                { text: '（4）今年二月下旬，銅鑼灣一帶已有木棉樹開花。' },
            ]
        },
        {
            type: 'display-text',
            html: '看過讀者留言後，你發現大家對樹木提早開花的原因有不同看法。網頁下方有一個「認識氣候變化」的延伸連結，你點進去繼續閱讀。<br/><br/>點擊「下一頁」來閱讀第二個來源。'
        },
        {
            id: '7',
            type: '選擇題',
            question: '7. 某城市大幅減少使用化石燃料後，仍然經常出現高溫、暴雨等極端天氣。根據科學文章，以下哪項解釋最有根據？',
            subtitle: '參考右側的「科學文章」，作答本題。',
            options: [
                { text: 'A. 化石燃料排放影響較小，減少使用作用有限' },
                { text: 'B. 人類排放大幅減少之後，自然因素成為主因' },
                { text: 'C. 過往排放仍在影響氣候，其他活動仍會排放' },
                { text: 'D. 減少化石燃料只能降溫，不能改變極端天氣' },
            ],
            tab: 1,
        },
        {
            id: '8',
            type: '選擇題',
            question: '8. 某沿海城市希望同時減少極端天氣的眼前影響，以及人類活動造成的長期氣候影響。綜合兩個來源，以下哪項方案最合適？',
            subtitle: '結合兩個來源，作答本題。',
            options: [
                { text: 'A. 增加防洪設施，長期記錄植物變化' },
                { text: 'B. 減少化石燃料，宣傳氣候變化知識' },
                { text: 'C. 長期記錄天氣，改善城市綠化環境' },
                { text: 'D. 加強排水清渠，減少化石燃料使用' },
            ],
            tab: 1,
        },
        {
            id: '9',
            type: '選擇題',
            question: '9. 子晴整理社論和科學文章時，想找出一項兩個來源都有直接提及的內容。以下哪項符合？',
            subtitle: '結合兩個來源，作答本題。',
            options: [
                { text: 'A. 極端天氣可能造成渠道淤塞和水浸' },
                { text: 'B. 植物開花、落葉等生長規律可能改變' },
                { text: 'C. 溫室氣體可以在大氣中停留很多年' },
                { text: 'D. 長期觀察可以確定氣候變化主要成因' },
            ],
            tab: 1,
        },
        {
            id: '10',
            type: '選擇題',
            question: '10. 綜合兩個來源，以下哪一組關係最能解釋植物花期提早值得持續關注的原因？',
            subtitle: '結合兩個來源，作答本題。',
            options: [
                { text: 'A. 暴雨增加 → 花期提早 → 水浸加劇' },
                { text: 'B. 全球變暖 → 花期改變 → 傳粉受影響' },
                { text: 'C. 花期提早 → 排放量增加 → 暖化加劇' },
                { text: 'D. 長期觀察 → 確定成因 → 證實暖化' },
            ],
            tab: 1,
        },
        {
            id: '11',
            type: '短句作答題',
            question: '11. 學校舉辦「校園氣候行動週」，請為宣傳海報擬寫一句不超過20字的標語，提醒同學關注氣候變化和身邊的環境變化。請綜合兩個來源，並說明理由。',
            subtitle: '結合兩個來源，作答本題。'
        }
    ]
}
